/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages

				// mobile menu trigger js
				$(".burger-trigger, .mobile-overlay, .close-trigger").click(function(e){
					e.preventDefault();
					// console.log('fired');
					$('.burger-trigger').toggleClass('open');
					$('.mobile-navigation-container').toggleClass('open');
					$('body').toggleClass('custom-overflow');
				});

				// main menu js
				$('#mobile-nav .menu-item-has-children .fa-angle-down, #mobile-nav .no-link > a').click(function(e){
					$(this).addClass('open');
					$(this).siblings('.sub-menu').slideToggle();
				});
				$('.no-link > a').on('click',function(e){
					e.preventDefault();
				});
				$('.cib-below-header--left .widget-title').click(function(e){
					$(this).siblings('[class*=menu-]').slideToggle();
				});

				// modal js
				$('.cib-modal--has-children > a').on('click',function(e){
					e.preventDefault();
					if($(this).hasClass('active')) {
						$(this).siblings('.cib-modal--children').slideUp();
						$(this).removeClass('active');
					} else {
						$('.link-trigger').removeClass('active');
						$('.cib-modal--children').slideUp();
						$(this).addClass('active');
						$(this).siblings('.cib-modal--children').slideDown();
					}
				});

				// ----- starts-open select fields
				// create the empty ul and edit span for each required instance
				$('.starts-open select').after('<ul class="starts-open--list"><span class="edit hidden">Edit</span></ul>');

				// create the options within the aforecreated list
				$('.starts-open select option').each(function(){
					$(this).parent().siblings('.starts-open--list').append('<li class="unselected" data-val="' + $(this).val() + '">' + $(this).text() + '</li>');
				});

				// hide an option if it has "select-hidden" as a value. This value is only used to work with conditional logic
				$('.starts-open--list li').each(function(){
					if($(this).text() == 'select-hidden') {
						$(this).removeClass('unselected');
						$(this).hide();
					}
				});

				// check if a value is already set on form navigation (back/forward/validation refresh)
				// because select fields have a default resting value, we have to check and see if the default value is the active one
				var navCheck;
				var navFound;
				$('.starts-open option').each(function(){
					if($(this).is(':selected') && $(this).text() != 'select-hidden') {
						navCheck = $(this).val();
						// console.log(navCheck);
						navFound = $(this).parent().siblings('.starts-open--list').find('li[data-val="' + navCheck + '"]');
						navFound.addClass('active');
						navFound.siblings('li.unselected').hide();
						navFound.siblings('.edit').removeClass('hidden');
					}
				});

				// list item checks
				$('.starts-open--list li').click(function(){
					if ($(this).hasClass('active')) {
						$(this).removeClass('active');
						$(this).siblings('li.unselected').show();
						$(this).siblings('.edit').addClass('hidden');
						$(this).parent().siblings('select').val('');
					} else {
						$(this).addClass('active');
						$(this).siblings('li.unselected').hide();
						$(this).siblings('.edit').removeClass('hidden');
						$(this).parent().siblings('select').val($(this).data('val')).trigger('change');
					}
				});

				// edit button functionality
				$('.starts-open--list .edit').click(function(){
					$(this).addClass('hidden');
					$(this).siblings('li.unselected').removeClass('active').show();
					$(this).parent().siblings('select').val('');
				});
				// ----- starts-open select fields ends here

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired

				// gravity form js
				// $('.starts-open select').trigger('chosen:open');
			}
		},

		// About us page, note the change from about-us to about_us.
		// 'page_template_page_about': {
			// init: function() {
				// JavaScript to be fired on the about us page
			// }
		// }
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


jQuery(window).load(function() {
	// starts open js
	// https://harvesthq.github.io/chosen/options.html
	// jQuery('.starts-open select').trigger('chosen:open');

	// jQuery('.active-result').on('click',function(){
	// 	jQuery(this).siblings('li').removeClass('active').hide();
	// 	jQuery(this).addClass('active');
	// });
	 

	// jQuery('.active-result').wrapInner('<span class="starts-open--value"></span>').append('<span class="starts-open--edit">Edit</span>');

	// jQuery('.starts-open--value').on('click',function(){
	// 	jQuery(this).parent().siblings('li').removeClass('active').hide();
	// 	jQuery(this).parent().addClass('active');
	// });

	// jQuery('.starts-open--edit').on('click',function(){
	// 	jQuery(this).parent().siblings('li').show();
	// 	jQuery(this).parent().removeClass('active');
	// });


	// jQuery('.starts-open select option').each(function(){
	// 	jQuery(this).siblings('.starts-open--list').append('<li>Test</li>');
	// });

});